/**
 * src/services/auth.service.js
 * Client-side authentication service using JWT
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

class AuthService {
  async login(username, password) {
    const response = await axios.post(`${API_URL}/api/auth/signin`, {
      username,
      password
    });

    if (response.data.accessToken) {
      this.setUser(response.data);
    }

    return response.data;
  }

  logout() {
    const refreshToken = this.getRefreshToken();

    // Call the signout endpoint
    if (refreshToken) {
      axios.post(`${API_URL}/api/auth/signout`, {
        refreshToken: refreshToken
      }).catch(error => console.error('Logout error:', error));
    }

    // Clear local storage
    localStorage.removeItem('user');
  }

  setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  getAccessToken() {
    const user = this.getUser();
    return user ? user.accessToken : null;
  }

  getRefreshToken() {
    const user = this.getUser();
    return user ? user.refreshToken : null;
  }

  isLoggedIn() {
    return !!this.getAccessToken();
  }

  isAdmin() {
    const user = this.getUser();
    return user && user.role === 'admin';
  }

  isEmployee() {
    const user = this.getUser();
    return user && user.role === 'employee';
  }

  async refreshToken() {
    try {
      const refreshToken = this.getRefreshToken();

      if (!refreshToken) {
        return false;
      }

      const response = await axios.post(`${API_URL}/api/auth/refreshtoken`, {
        refreshToken: refreshToken
      });

      const user = this.getUser();
      user.accessToken = response.data.accessToken;

      this.setUser(user);
      return true;
    } catch (error) {
      console.error('Token refresh error:', error);
      this.logout();
      return false;
    }
  }
}

export default new AuthService();